import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ["mainDashboard", "journey", "ticket", "3333", "4444", "5555", "6666", "7777", "8888", "9999"]

  connect() {
    this.controllerName = `financials--books--receivables--tickets--dashboard`
  }

  doTicketsDashboard() {
    var html = `<div class="row" data-${this.controllerName}-target="mainDashboard">
                  <div class="col-12 pl-1" data-users--works--activities--shared--tickets-target="main" data-controller="users--works--activities--shared--tickets"></div>
                </div>`

    var controller = this
    new Promise(function (resolve) {
      resolve(controller.getControllerByIdentifier(`financials--books--receivables--dashboard--main`).contentTarget.innerHTML = html)
    }).then(() => {
      controller.getControllerByIdentifier(`financials--books--receivables--dashboard--submenu`).dashboardToggleBtn(`TICKETS`)

      controller.getControllerByIdentifier(`users--works--activities--shared--tickets`).permission = `financial_receivable_tickets`
      controller.getControllerByIdentifier(`users--works--activities--shared--tickets`).itemsOnRow = 5
      controller.getControllerByIdentifier(`users--works--activities--shared--tickets`).kind = true
      controller.getControllerByIdentifier(`users--works--activities--shared--tickets`).priority = true
      controller.getControllerByIdentifier(`users--works--activities--shared--tickets`).term = true
      controller.getControllerByIdentifier(`users--works--activities--shared--tickets`).ticket_count_controller = controller.getControllerByIdentifier(`financials--books--receivables--dashboard--submenu`)
      controller.getControllerByIdentifier(`users--works--activities--shared--tickets`).ticket_board = {
        board_id: this.application.current_date.id,
        board_type: `financial_receivables`,
        board_subtype: `financial_receivables`,
        board_path: window.location.pathname,
        board_name: `Contas à Receber - ${this.application.current_date.name}`,
        date_id: this.application.current_date.id,
        date_type: `financials_dates`
      }
      controller.getControllerByIdentifier(`users--works--activities--shared--tickets`).comment_board = {
        board_id: this.application.current_date.id,
        board_type: `financial_receivables`,
        date_id: this.application.current_date.id,
        date_type: `financials_dates`
      }

      controller.getControllerByIdentifier(`users--works--activities--shared--tickets`).doIndexListHtml()

    })
  }

  getControllerByIdentifier(identifier) {
    return this.application.controllers.find(controller => {
      return controller.context.identifier === identifier;
    });
  }

  nameTarget(target) {
    return this.targets.find(target)
  }

  // new Promise(function (resolve) {
  //   resolve()
  // }).then(() => {
  // }) 

}
